
export enum CookieConstants {
    UserIdentityCookie = "User.Identity"
}